import React, { Component } from 'react';

import CToolTips from '../Tooltips';

export default class DropDown extends Component {
	constructor(props) {
		super(props);
		this.dropdownMenu = React.createRef();
		this.toggleTimeout = null;
	}

	state = {
		showChildren: false,
	};

	componentDidUpdate(prevProps) {
		const { showMenu } = this.props;

		if (prevProps.showMenu !== showMenu) {
			if (showMenu === true) {
				clearTimeout(this.toggleTimeout);
				this.setState({
					showChildren: true,
				});
			} else {
				clearTimeout(this.toggleTimeout);

				this.toggleTimeout = setTimeout(() => {
					this.setState({
						showChildren: false,
					});
				}, 350);
			}
		}
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.closeMenu);
		clearTimeout(this.toggleTimeout);
	}

	showMenu = () => {
		this.props.toggleMenu(true, () => {
			setTimeout(() => {
				document.addEventListener('click', this.closeMenu);
			}, 0);
		});
	};

	closeMenu = event => {
		const { closeOnSelect, toggleMenu } = this.props;

		if (
			!!this.dropdownMenu &&
			((this.dropdownMenu.current &&
				!this.dropdownMenu.current.contains(event.target)) ||
				closeOnSelect)
		) {
			toggleMenu(false, () => {
				setTimeout(() => {
					document.removeEventListener('click', this.closeMenu);
				}, 0);
			});
		}
	};

	render() {
		const {
			position,
			className,
			showMenu,
			activeClassName,
			renderSelected,
			children,
			ttStyle,
		} = this.props;

		return (
			<CToolTips
				position={position || 'down'}
				inFocus={showMenu}
				className={`inline-block cursor-pointer ${className} ${
					showMenu ? activeClassName : ''
				}`}
				onClick={this.showMenu}
				wrappedContent={renderSelected}
				ttStyle={ttStyle}
			>
				{this.state.showChildren && (
					<div ref={this.dropdownMenu}>{children}</div>
				)}
			</CToolTips>
		);
	}
}
